import React, { useState, useEffect } from 'react'
import { View, Text, Heading, Button, TextField, Flex, Divider, SwitchField} from '@aws-amplify/ui-react';
import Loadingmini from './loadingmini';
import { API, Auth } from 'aws-amplify';
import Searchselect from './searchselect';
import { fetchPaginatedAgoList } from '../paginatedAgoFetch';

export const Messagecreate = ({fleetCode, refreshParent, drivers, selectedDriver, selectedRecipientName}) => {
  const [is_loading, updateIsLoading] = React.useState(false);
  const [displayWindow, updateDisplayWindow] = useState(false);
  const [submitError, updateSubmitError] = useState(false);
  const [showConfirm, updateShowConfirm] = useState(false);
  const [messageText, updateMessageText] = useState("");
  const [driverId, updateDriverId] = useState(0);
  const [selectedDriverName, updateSelectedDriverName] = useState(selectedRecipientName);
  const [driverList, updateDriverList] = useState(drivers);
  const [loadError, updateLoadError] = useState("");
  const [driverSearchSelectActive, updateDriverSearchSelectActive] = useState(false);
  const [showSendResults, updateShowSendResults] = useState(false);
  const [send_status_chat, updateSendStatusChat] = useState(false);
  const [send_status_push, updateSendStatusPush] = useState(false);
  const [send_status_sms, updateSendStatusSms] = useState(false);
  const [message_medium, updateMessageMedium] = useState(["app_chat", "push", "sms"]);

  async function toggleMedium(medium) {
    if (message_medium.includes(medium)) {
      updateMessageMedium(message_medium.filter(m => m !== medium));
    } else {
      updateMessageMedium([...message_medium, medium]);
    }
  }

  async function fetchData() {
    updateIsLoading(true)
    updateLoadError("");
    if(selectedDriver)
    {
      if(selectedDriver > 0)
      {
        updateDriverId(selectedDriver)
      }
    }
    if(typeof(drivers) !== 'undefined' && typeof(drivers[0]) !== 'undefined')
    {
      updateDriverList(drivers);
      updateIsLoading(false);
      return;
    }

    const driverResult = await fetchPaginatedAgoList({
      api_endpoint: "api3:staff:drivers",
      fleet_code: fleetCode,
      mode: "picker",
    });
    if (!driverResult.ok) {
      updateLoadError(driverResult.error);
      updateDriverList([]);
      updateIsLoading(false);
      return;
    }
    updateDriverList(driverResult.items);
    updateIsLoading(false);
  }
  useEffect(() => {
    fetchData();
  },[])



  async function submitForm() {
    if(messageText!=="")
    {
        updateIsLoading(true)
        updateSubmitError(false)
        let session = await Auth.currentSession()      
        let accessToken = await session.getAccessToken()
        var jwt = await accessToken.getJwtToken()
        const myInit = {queryStringParameters:{ 
            "back_end": process.env.REACT_APP_BACKEND,
            "jwt": jwt,
            "api_endpoint": "api3:staff:message_send",
            "fleet_code":fleetCode,
            "message":messageText,
            "medium_set":true,
            "medium_lilou": message_medium.includes("app_chat"),
            "medium_push": message_medium.includes("push"),
            "medium_sms": message_medium.includes("sms"),
            "recipient_id":driverId
        }};
        //console.log('init: ' + JSON.stringify(myInit)) //temporary
        try {
            const res = await API.get('adminWebTools','/ago',myInit)
            //console.log('res: ' + JSON.stringify(res)) //temporary
            if('detail' in res)
            {
              updateSubmitError(res['detail'])
            } else {
              updateMessageText("");
              updateShowConfirm(false);
              //refreshParent();
              if(typeof(res.messages[0]) !== 'undefined')
              {
                updateShowSendResults(true)
                updateSendStatusChat(res.messages[0]['lilou_status'])
                updateSendStatusPush(res.messages[0]['push_status'])
                updateSendStatusSms(res.messages[0]['sms_status'])
                if(res.messages[0]['lilou_status']==='success')
                {
                  refreshParent();
                }
              } else {
                updateShowSendResults(true)
                updateSendStatusChat("Error:  "+JSON.stringify(res))
                updateSendStatusPush("Please contact developer@joinago.com")
                updateSendStatusSms("error - messages not found")
              }
            }
        }
        catch (e) {
            console.log('submit form error: '+toString(e));
            var thisError = toString(e)
            updateSubmitError(thisError)
        }
        updateIsLoading(false)
    }
  }

  async function dismissSendResults()
  {
    updateShowSendResults(false)
    updateSendStatusChat(false)
    updateSendStatusPush(false)
    updateSendStatusSms(false)
    updateDisplayWindow(false)
  }

  async function handleupdateDriverSearchSelectActive(val) {
    /*  only needed if vehicle search also being used in same component
    updateDriverSearchSelectActive(val);
    if(val)
    {
      updateVehicleSearchSelectActive(false);
    }
      */
  }

  return (<View style={{flex:1}}>
    {
      is_loading ? <Loadingmini /> : 
      displayWindow ? 
        <View>
          <Divider />
          <Heading level={2}>New Message</Heading>
          {loadError ? <Text color="red">{loadError}</Text> : null}
          {
            showConfirm === false ?
            showSendResults ? 
              <View>
                <br />
                <Heading level={4}>Message Sent</Heading>
                <Text>To:  {selectedDriverName}</Text>
                <Text>{messageText}</Text>
                <br />
                <Text>Chat Status:  {send_status_chat}</Text>
                {/*<Text>PUSH Status:  {send_status_push}</Text>*/}
                <Text>SMS Status:  {send_status_sms}</Text>
                <br />
                <br />
                <Button onClick={() => dismissSendResults()}>
                    DISMISS
                </Button>
                <br />
                <br/>
              </View>
              :
              <View>
                <Text>To:</Text>
                <Searchselect searchType="driver" objects={driverList} selectObject={updateDriverId} selectedObject={driverId} updateSelectedObjectName={updateSelectedDriverName} selectedObjectName={selectedDriverName} updateSearchSelectActive={handleupdateDriverSearchSelectActive}/>
                <br/>
                <Text>Message:</Text>
                <TextField
                    placeholder='Type here...'
                    onInput={(e) => updateMessageText(e.target.value)}
                    as="textarea"
                    isRequired={true}
                ></TextField>
                <br />
                <Button onClick={() => updateShowConfirm(true)}>
                    SUBMIT
                </Button>
                <br />
                <br />
                <Button onClick={() => updateDisplayWindow(false)}>
                    CANCEL
                </Button>
                <br/>
                <br/>
              </View>
            :
            submitError ? 
              <View>
                <Heading level={4}>Error</Heading>
                <Text>{JSON.stringify(submitError)}</Text>
                <br />
                <br />
                <Button onClick={() => updateShowConfirm(false)}>
                    TRY AGAIN
                </Button>
                <br/>
                <br />
              </View>
            :
              <View>
                <br/>
                <Heading level={4}>Select Method</Heading>
                <Text>To:  {selectedDriverName}</Text>
                <Text>{messageText}</Text>
                <br />
                <br />
                <Heading level={5}>Message Methods</Heading>
                <Flex direction="column" gap="1em">
                  {
                  /*["app_chat", "push", "sms"].map((medium) => (    */
                  ["app_chat", "sms"].map((medium) => (
                    <Flex key={medium} direction="row" alignItems="center" justifyContent="space-between">
                      <Text>{medium.toUpperCase()}</Text>
                      <SwitchField
                        isChecked={message_medium.includes(medium)}
                        onChange={() => toggleMedium(medium)}
                      />
                    </Flex>
                  ))}
                </Flex>
                <br/>
                <br/>
                <Button onClick={() => submitForm()}>
                    SEND
                </Button>
                <br />
                <br />
                <Button onClick={() => updateShowConfirm(false)}>
                    CANCEL
                </Button>
                <br/>
                <br/>
              </View>
          }


          
        </View>
      :
        <Flex flexDirection='row' justifyContent='flex-end' alignItems='flex-end' alignContent='flex-end' gap='1em'>
          <Button onClick={() => updateDisplayWindow(true)}>
            NEW MESSAGE
          </Button>
        </Flex>
    }
  </View>);
};

export default Messagecreate;